import { axios } from "../../helper/axios";
import { CustomerDetailConstant } from "./customerDetailConstant";

const customerDetailApi = {};

customerDetailApi.getpersonalDetail = ({ id }) => {
  return axios.get(
    CustomerDetailConstant.PERSONAL_DETAIL_API.replace(":id", id)
  );
};

customerDetailApi.getreviews = ({ id }) => {
  return axios.get(CustomerDetailConstant.REVIEWS_API.replace(":id", id));
};

customerDetailApi.getChargingData = ({ id }) => {
  return axios.get(CustomerDetailConstant.CHARGING_DATA_API.replace(":id", id));
};

export { customerDetailApi };
